import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSetGoalContext } from '../../context/useSetGoalContext';
import { FormValues } from './TargetDate.meta';
import { StepCard } from '../../../PulseCheck.styles';
import { cardAnimationVariants } from '../../../../BeFi20/BeFi20.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { SingleDatePicker } from '../../../../CommonComponents/OPL/dates/SingleDatePicker/SingleDatePicker';
import {
  dateToISO8601,
  iso8601ToDate,
} from '../../../../AccountPerformanceReporting/helpers/dates';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { FORM_ID } from '../../SetGoal.meta';
import { StepWrapper } from '../../../components/StepWrapper/StepWrapper';

export const TargetDate = () => {
  const todayDate = new Date();

  const { wizard, setWizard, onSuccess } = useSetGoalContext();

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      targetDate: wizard.targetDate || dateToISO8601(todayDate),
    },
  });

  const onSubmit = handleSubmit(values => {
    const newWizard = { ...wizard, ...values };

    setWizard(newWizard);

    onSuccess(newWizard);
  });

  return (
    <StepWrapper as="form" id={FORM_ID} onSubmit={onSubmit}>
      <StepCard variants={cardAnimationVariants} initial="enter" animate="visible">
        <Text as="h1" fontSize="h4" fontWeight={600} mb="16">
          When would you like to have this done by?
        </Text>

        <Box width={160}>
          <Text variant="formLabel" mb="4">
            Target Date
          </Text>

          <Controller
            control={control}
            name="targetDate"
            render={({ field: { value, onChange } }) => (
              <SingleDatePicker
                date={iso8601ToDate(value)}
                onChange={newDate => onChange(dateToISO8601(newDate))}
                minDate={todayDate}
              />
            )}
          />
        </Box>
      </StepCard>
    </StepWrapper>
  );
};
